import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { OrderConfirmationTotalsComponent } from '@spartacus/order/components';

@Component({
  selector: 'gen-order-confirmation-totals',
  templateUrl: './order-confirmation-totals.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenOrderConfirmationTotalsComponent extends OrderConfirmationTotalsComponent implements OnDestroy { }
